export default "__VITE_ASSET__bBOPTmUK__"